import React from "react";
import "./mapa.css";
import mapa from "../../assets/mapa/mapa.jpeg";

const LEGENDA = [
  "01 – RECEPÇÃO E TRANSFER CENTRO DE CONVENÇÕES",
  "02 – HAPPY HOUR E JANTAR – SALÃO OURO PRETO",
  "03 – BAR DO LOBBY / AFTER",
  "04 – PISCINA / SUNSET",
  "05 – ACESSO PRAIA / ARENA DE ESPORTES",
  "06 – RESTAURANTE PRINCIPAL",
];

const Mapa = () => {
  return (
    <div className="main">
      <div className="mapa-container">
        <img src={mapa} alt="Mapa" className="mapa" />
        <ul className="mapa-legenda">
          {LEGENDA.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Mapa;
